import { useToast, Tooltip } from "@aidkitorg/component-library";
import { Square2StackIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";
import { useLocalizedStrings } from "../Localization";
import { copyToClipboard } from "../Util";
import { HasEnableKey, calcEnableKey, enableKeyIsValid } from "@aidkitorg/types/lib/eval";
import { hash } from "@aidkitorg/types/lib/translation/v0_to_legacy";

export function EnableKey({ component, parts, parentComponent }: { component: HasEnableKey, parts?: string[], parentComponent?: HasEnableKey }) {
  const expectedLatest = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component), calcEnableKey(component, {}, JSON.stringify)], [component, parts]);
  const expectedV3 = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component, { version: 'v3' }), calcEnableKey(component, { version: 'v3' }, JSON.stringify)], [component, parts]);
  const expectedV2 = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component, { version: 'v2' }), calcEnableKey(component, { version: 'v2' }, JSON.stringify)], [component, parts]);
  const expectedV1 = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component, { version: 'v1' }), calcEnableKey(component, { version: 'v1' }, JSON.stringify)], [component, parts]);
  const expectedV0 = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component, { version: 'v0' }), calcEnableKey(component, { version: 'v0' }, JSON.stringify)], [component, parts]);
  // unused because we want validation to show regardless of flup enable status, but keeping for reference.
  const _isComponentEnabled = useMemo(() => {
    return expectedLatest.includes(component.enableKey) || expectedV3.includes(component.enableKey) || expectedV2.includes(component.enableKey) || expectedV1.includes(component.enableKey) || expectedV0.includes(component.enableKey);
  }, [component, expectedLatest, expectedV3, expectedV2, expectedV1, expectedV0]);

  const isParentEnabled = useMemo(() => {
    return parentComponent && enableKeyIsValid(parentComponent.enableKey, parentComponent, { allowVersions: true });
  }, [parentComponent]);

  const L = useLocalizedStrings();
  const { toast } = useToast();

  function copy(str: string) {
    const { dismiss } = toast({
      description: `Hash ${L.copied_to_clipboard}`
    });
    copyToClipboard(str);
    setTimeout(() => dismiss(), 1500);
  }

  return <>
    <b>{expectedLatest[0] === component.enableKey
      ? 'Enabled'
      : expectedLatest[1] === component.enableKey
        ? <span className="text-red-500">Enabled but outdated, please set to <b>{expectedLatest[0]}</b></span>
        : expectedV3[0] === component.enableKey || expectedV3[1] === component.enableKey
          ? <span className="text-red-500">Enabled (v3) but outdated, please set to <b>{expectedLatest[0]}</b></span>
          : expectedV2[0] === component.enableKey || expectedV2[1] === component.enableKey
            ? <span className="text-red-500">Enabled (v2) but outdated, please set to <b>{expectedLatest[0]}</b></span>
            : expectedV1[0] === component.enableKey || expectedV1[1] === component.enableKey
              ? <span className="text-red-500">Enabled (v1) but outdated, please set to <b>{expectedLatest[0]}</b></span>
              : expectedV0[0] === component.enableKey || expectedV0[1] === component.enableKey
                ? <span className="text-red-500">Enabled (v0) but outdated, please set to <b>{expectedLatest[0]}</b></span>
                : 'Not Enabled. Key is: ' + expectedLatest[0]}</b>
    <Tooltip text="Copy Hash to clipboard">
      <Square2StackIcon className="align-super w-5 h-5 cursor-pointer" onClick={() => copy(expectedLatest[0])} />
    </Tooltip>
    {parentComponent && !isParentEnabled && <div className="text-red-500 mt-1 text-sm">Parent Notif not enabled; followups will not be sent.</div>}
    {parentComponent && isParentEnabled && <div className="text-gray-600 mt-1 text-sm">Flup will only be sent if parent notif was sent</div>}
  </>
}
